'use strict';
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
const RVL_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
const RVL_RATE = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
const RVL_MONEY = new Intl.NumberFormat('en-GB', { style: 'currency', currency: RVL_CURRENCY });
/* cents already in the customer's currency (e.g. /cart.js) */
function formatMoney(cents) { return RVL_MONEY.format((Number(cents) || 0) / 100); }
/* cents in the shop currency (e.g. product JSON, /recommendations) converted to the market currency */
function formatShopMoney(cents) { return formatMoney(Math.round((Number(cents) || 0) * RVL_RATE)); }

(function initNavbarScroll(){
  const navbar = $('.navbar'); if (!navbar) return;
  const update = () => navbar.classList.toggle('scrolled', window.scrollY > 20);
  on(window, 'scroll', update, { passive: true }); update();
})();

(function initMegaMenu(){
  $$('.nav-item').forEach(item => {
    let timer; const menu = item.querySelector('.mega-menu'); if (!menu) return;
    on(item, 'mouseenter', () => { clearTimeout(timer); item.classList.add('open'); });
    on(item, 'mouseleave', () => { timer = setTimeout(() => item.classList.remove('open'), 120); });
    const trigger = item.querySelector('.nav-link');
    on(trigger, 'keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.classList.toggle('open'); }
      if (e.key === 'Escape') item.classList.remove('open');
    });
  });
  on(document, 'click', e => { if (!e.target.closest('.nav-item')) $$('.nav-item').forEach(i => i.classList.remove('open')); });
})();

function openMobileMenu() { $('#mobile-nav')?.classList.add('open'); $('#overlay')?.classList.add('active'); document.body.style.overflow = 'hidden'; }
function closeMobileMenu() { $('#mobile-nav')?.classList.remove('open'); $('#overlay')?.classList.remove('active'); document.body.style.overflow = ''; }
(function initMobileNav(){
  on($('.hamburger'), 'click', openMobileMenu);
  on($('.mobile-nav__close'), 'click', closeMobileMenu);
  on(document, 'keydown', e => { if (e.key === 'Escape') closeMobileMenu(); });
})();

function showToast(message, type = '', duration = 2800) {
  const toast = $('#toast'); if (!toast) return;
  toast.textContent = message;
  toast.className = 'toast show' + (type ? ' toast--' + type : '');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => { toast.className = 'toast'; }, duration);
}

/* ===== CART REDESIGN ===== */
/* Rivelia cart drawer visibility and quantity fix */
function paymentLogosHtml() {
  const template = document.getElementById('drawer-payment-logos-template');
  if (template && template.innerHTML.trim()) return template.innerHTML;
  return '<div class="cart-drawer-payment-label">Accepted payments</div>';
}

const RIVELIA_PROTECTION_VARIANT_ID = 54219855659355;

/* ===== CHRISTMAS FREE GIFT ===== */
const RVL_GIFT_HANDLES = ['echarpe-femme-carreaux-franges-tissee-finition-brossee-douce','bonnet-femme-maille-cotelee-a-revers-coupe-ample','womens-100-cashmere-gloves-soft-warm-winter-gloves'];
const RVL_GIFT_NAMES = ['Scarf','Beanie','Gloves'];
const RVL_GIFT_STORE = 'rvl_xmas_gift';
const RVL_GIFT_MIN_ITEMS = 2;
function rvlGiftCompare(item) { try { const cat = rvlGiftCatalog || []; for (const p of cat) { const v = p.variants.find(x => x.id === Number(item.variant_id)); if (v && v.compare > 0) return v.compare * (item.quantity || 1); } } catch (e) {} return Number(item.original_line_price || 0); }
function rvlImg(u) { if (!u) return ''; u = String(u); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240'; }
function rvlPickGift(cat, st) { const vid = Number(st && st.variantId) || 0; let first = null; for (const p of (cat || [])) { for (const v of p.variants) { if (v.id === vid && v.available) return { p: p, v: v }; if (!first && v.available) first = { p: p, v: v }; } } return first; }
function rvlIsGift(item) { return !!(item && item.properties && item.properties._xmas_gift); }
function rvlGiftState() { try { return JSON.parse(sessionStorage.getItem(RVL_GIFT_STORE) || 'null') || {}; } catch (e) { return {}; } }
function rvlSaveGiftState(patch) { const s = Object.assign(rvlGiftState(), patch); try { sessionStorage.setItem(RVL_GIFT_STORE, JSON.stringify(s)); } catch (e) {} return s; }
window.rvlGiftSkip = function () { rvlSaveGiftState({ skip: true }); };
let rvlGiftCatalog = null;
async function rvlLoadGiftCatalog() {
  if (rvlGiftCatalog) return rvlGiftCatalog;
  const out = [];
  await Promise.all(RVL_GIFT_HANDLES.map(async (handle, i) => {
    try {
      const res = await fetch('/products/' + handle + '.js'); if (!res.ok) return;
      const prod = await res.json();
      out[i] = { handle: handle, name: RVL_GIFT_NAMES[i], title: prod.title, variants: prod.variants.map(v => ({ id: Number(v.id), title: v.title === 'Default Title' ? 'One Size' : v.title, available: !!v.available, compare: Number(v.compare_at_price || 0), img: rvlImg((v.featured_image && v.featured_image.src) || prod.featured_image) })) };
    } catch (e) {}
  }));
  rvlGiftCatalog = out.filter(Boolean);
  return rvlGiftCatalog;
}
(function rvlGiftCss() {
  if (document.getElementById('rvl-gift-css')) return;
  const st = document.createElement('style'); st.id = 'rvl-gift-css';
  st.textContent = '.cart-item--gift{background:#FBF3F2;border-radius:10px;padding:10px;margin:6px 0}.rvl-gift-badge{display:inline-block;padding:2px 9px;border-radius:999px;background:#7A1F2B;color:#fff;font-size:10px;letter-spacing:.12em;text-transform:uppercase}.rvl-gift-change{display:block;margin-top:6px;font-size:11px;color:#6B3A42}.rvl-gift-change select{display:block;margin-top:3px;width:100%;max-width:220px;padding:5px 8px;border:1px solid #E3C4C4;border-radius:6px;background:#fff;font:inherit;font-size:12px;color:#2B1517}.rvl-gift-qty{font-size:11px;color:#6B3A42}.rvl-gift-restore{display:block;width:100%;margin:8px 0;padding:10px;border:1px dashed #7A1F2B;border-radius:8px;background:#FBF3F2;color:#7A1F2B;font:inherit;font-size:12px;cursor:pointer}.cart-item__price-current.is-free{color:#7A1F2B;font-weight:700}.cart-item--gift-locked{position:relative}.cart-item--gift-locked .cart-item__img{opacity:.78}.rvl-gift-lock{position:absolute;left:16px;top:86px;width:24px;height:24px;border-radius:50%;background:#7A1F2B;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 4px rgba(0,0,0,.25)}.rvl-gift-lock svg{width:13px;height:13px}.rvl-gift-unlock{font-size:11px;font-weight:600;color:#7A1F2B;line-height:1.3}';
  document.head.appendChild(st);
})();

const Cart = {
  async getCart() { const res = await fetch('/cart.js'); return res.json(); },
  async addItem(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity }) });
    if (!res.ok) { let msg = 'Product unavailable'; try { const err = await res.json(); msg = err.description || err.message || msg; } catch(e) {} throw new Error(msg); }
    return res.json();
  },
  async removeItem(key) {
    const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
    return res.json();
  },
  async changeItem(key, quantity) {
    const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) });
    return res.json();
  },
  async addGift(variantId) {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1, properties: { _xmas_gift: '1' } }) });
    if (!res.ok) throw new Error('Gift unavailable');
    return res.json();
  },
  /* Returns true when the cart was changed (gift added, swapped or removed). */
  async syncGift(cart) {
    if (this._giftBusy) return false;
    this._giftBusy = true;
    try {
      const items = cart.items || [];
      const eligibleQty = items.reduce((s, i) => (Number(i.variant_id) === RIVELIA_PROTECTION_VARIANT_ID || rvlIsGift(i)) ? s : s + i.quantity, 0);
      const gifts = items.filter(rvlIsGift);
      const st = rvlGiftState();
      let changed = false;
      if (eligibleQty < RVL_GIFT_MIN_ITEMS || st.skip) {
        for (const g of gifts) { await this.changeItem(g.key, 0); changed = true; }
        return changed;
      }
      const cat = await rvlLoadGiftCatalog();
      let vid = Number(st.variantId) || 0;
      if (!cat.some(p => p.variants.some(v => v.id === vid && v.available))) {
        const first = cat.map(p => p.variants.find(v => v.available)).find(Boolean);
        vid = first ? first.id : 0;
      }
      if (!vid) return false;
      const right = gifts.find(g => Number(g.variant_id) === vid);
      for (const g of gifts) { if (g !== right) { await this.changeItem(g.key, 0); changed = true; } }
      if (right) { if (right.quantity !== 1) { await this.changeItem(right.key, 1); changed = true; } }
      else { await this.addGift(vid); changed = true; }
      return changed;
    } catch (e) { return false; }
    finally { this._giftBusy = false; }
  },
  async render() {
    let cart = await this.getCart();
    try { if (await this.syncGift(cart)) cart = await this.getCart(); } catch (e) {}
    const rvlGiftSt = rvlGiftState();
    const rvlCat = (cart.items.some(rvlIsGift) || !rvlGiftSt.skip) ? await rvlLoadGiftCatalog() : [];
    this.updateCount(cart.item_count - cart.items.filter(rvlIsGift).length);
    const body = $('#cart-drawer-body');
    const footer = $('#cart-drawer-footer');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty__title">Your basket is empty</div>
          <p class="cart-empty__text">Discover our selection<br>of elegant pieces.</p>
          <a href="/collections" class="btn btn--dark" onclick="toggleCart(false)" style="display:inline-flex;padding:12px 28px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:600">View our collections</a>
        </div>`;
      if (footer) footer.innerHTML = '';
      return;
    }

        /* MULTI-ITEM DISCOUNT PROGRESS BAR */
    var goalHtml = '';
    var qty = cart.items.reduce(function(sum, item) {
      return (Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID || rvlIsGift(item)) ? sum : sum + item.quantity;
    }, 0);

    var pct = Math.min(100, (qty / 4) * 100);
    var label = '';

    var rvlFg = rvlGiftSt.skip ? '' : ' + free gift';
    if (qty < 2) {
      var remaining15 = 2 - qty;
      label = 'Add ' + remaining15 + ' more item' + (remaining15 > 1 ? 's' : '') + ' and get <strong>-15%</strong>' + (rvlGiftSt.skip ? '' : ' + a <strong>free gift</strong>');
    } else if (qty === 2) {
      label = '✓ <strong>-15%' + rvlFg + '</strong> unlocked · add 1 more item to get <strong>-20%</strong>';
    } else if (qty === 3) {
      label = '✓ <strong>-20%' + rvlFg + '</strong> unlocked · add 1 more item to get <strong>-25%</strong>';
    } else {
      label = '✓ Maximum <strong>-25%' + rvlFg + '</strong> unlocked';
    }

    goalHtml = `
      <div class="cart-goal${qty >= 4 ? ' cart-goal--done' : ''}">
        <div class="cart-goal__text">${label}</div>
        <div class="cart-goal__track">
          <div class="cart-goal__fill" style="width:${pct}%"></div>
          <div class="cart-goal__milestone ${qty >= 2 ? 'is-reached' : ''}" style="left:50%"><span>2</span></div>
          <div class="cart-goal__milestone ${qty >= 3 ? 'is-reached' : ''}" style="left:75%"><span>3</span></div>
          <div class="cart-goal__milestone ${qty >= 4 ? 'is-reached' : ''}" style="left:100%"><span>4</span></div>
        </div>
        <div class="cart-goal__labels">
          <span style="left:50%">-15%</span>
          <span style="left:75%">-20%</span>
          <span style="left:100%">-25%</span>
        </div>
      </div>`;

    var visualTierRate = qty >= 4 ? 0.25 : (qty >= 3 ? 0.20 : (qty >= 2 ? 0.15 : 0));
    var visualTierPct = qty >= 4 ? 25 : (qty >= 3 ? 20 : (qty >= 2 ? 15 : 0));
    var eligibleBaseSubtotal = cart.items.reduce(function(sum, item) {
      if (Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID || rvlIsGift(item)) return sum;
      return sum + Number(item.original_line_price || item.final_line_price || 0);
    }, 0);
    var protectionSubtotal = cart.items.reduce(function(sum, item) {
      if (Number(item.variant_id) !== RIVELIA_PROTECTION_VARIANT_ID) return sum;
      return sum + Number(item.final_line_price || item.original_line_price || 0);
    }, 0);
    var giftFinalSubtotal = cart.items.reduce(function(sum, item) { return rvlIsGift(item) ? sum + Number(item.final_line_price || 0) : sum; }, 0);
    var giftSavings = cart.items.reduce(function(sum, item) { return rvlIsGift(item) ? sum + Math.max(0, rvlGiftCompare(item) - Number(item.final_line_price || 0)) : sum; }, 0);
    var visualTierSavings = cart.items.reduce(function(sum, item) {
      if (Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID || rvlIsGift(item)) return sum;
      return sum + Math.floor(Number(item.original_line_price || item.final_line_price || 0) * visualTierPct / 100);
    }, 0);
    var visualCartTotal = eligibleBaseSubtotal - visualTierSavings + protectionSubtotal + giftFinalSubtotal;

    function drawerPriceHtml(item) {
      var baseLine = Number(item.original_line_price || item.final_line_price || 0);

      if (Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID) {
        var protectionLine = Number(item.final_line_price || item.original_line_price || 0);
        return '<span class="cart-item__price">' + formatMoney(protectionLine) + '</span>';
      }

      /* Only the genuine multi-item discount is shown: the struck-through price is the real current price. */
      if (visualTierRate <= 0) {
        return '<span class="cart-item__price">' + formatMoney(baseLine) + '</span>';
      }
      var visualCurrentLine = baseLine - Math.floor(baseLine * visualTierPct / 100);

      return `
        <span class="cart-item__price-stack">
          <span class="cart-item__price-old">${formatMoney(baseLine)}</span>
          <span class="cart-item__price cart-item__price-current">${formatMoney(visualCurrentLine)}</span>
        </span>`;
    }

    function giftLineHtml(item) {
      var base = rvlGiftCompare(item), fin = Number(item.final_line_price || 0);
      var free = fin === 0;
      var priceHtml = free
        ? '<span class="cart-item__price-stack"><span class="cart-item__price-old">' + formatMoney(base) + '</span><span class="cart-item__price cart-item__price-current is-free">FREE</span></span>'
        : '<span class="cart-item__price">' + formatMoney(fin) + '</span>';
      var opts = rvlCat.map(function(p) {
        return '<optgroup label="' + p.name + '">' + p.variants.map(function(v) {
          return '<option value="' + v.id + '"' + (Number(item.variant_id) === v.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + v.title + '</option>';
        }).join('') + '</optgroup>';
      }).join('');
      return `
      <div class="cart-item cart-item--gift">
        <img class="cart-item__img" src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="107">
        <div class="cart-item__info">
          <div>
            <div class="cart-item__vendor"><span class="rvl-gift-badge">Free gift</span></div>
            <div class="cart-item__name">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            ${opts ? `<label class="rvl-gift-change">Change your gift<select data-gift-change>${opts}</select></label>` : ''}
          </div>
          <div class="cart-item__bottom">
            <span class="rvl-gift-qty">Qty 1</span>
            <div style="display:flex;align-items:center;gap:12px">
              ${priceHtml}
              <span class="cart-item__remove" data-key="${item.key}" data-gift="1">Remove</span>
            </div>
          </div>
        </div>
      </div>`;
    }
    function giftTeaserHtml() {
      if (rvlGiftSt.skip || qty < 1 || qty >= RVL_GIFT_MIN_ITEMS) return '';
      var pick = rvlPickGift(rvlCat, rvlGiftSt); if (!pick) return '';
      var v = pick.v, p = pick.p;
      var more = RVL_GIFT_MIN_ITEMS - qty;
      var opts = rvlCat.map(function(pp) {
        return '<optgroup label="' + pp.name + '">' + pp.variants.map(function(vv) {
          return '<option value="' + vv.id + '"' + (vv.id === v.id ? ' selected' : '') + (vv.available ? '' : ' disabled') + '>' + vv.title + '</option>';
        }).join('') + '</optgroup>';
      }).join('');
      var base = v.compare > 0 ? v.compare : 0;
      var lock = '<span class="rvl-gift-lock" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg></span>';
      return `
      <div class="cart-item cart-item--gift cart-item--gift-locked">
        <img class="cart-item__img" src="${v.img || p.img || ''}" alt="${p.title}" loading="lazy" width="80" height="107">
        ${lock}
        <div class="cart-item__info">
          <div>
            <div class="cart-item__vendor"><span class="rvl-gift-badge">Free gift</span></div>
            <div class="cart-item__name">${p.title}</div>
            ${v.title !== 'One Size' ? `<div class="cart-item__variant">${v.title}</div>` : ''}
            <label class="rvl-gift-change">Choose your gift<select data-gift-change>${opts}</select></label>
          </div>
          <div class="cart-item__bottom">
            <span class="rvl-gift-unlock">Add ${more} more item${more > 1 ? 's' : ''} to unlock</span>
            <span class="cart-item__price-stack">${base ? '<span class="cart-item__price-old">' + formatMoney(base) + '</span>' : ''}<span class="cart-item__price cart-item__price-current is-free">FREE</span></span>
          </div>
        </div>
      </div>`;
    }
    var giftRestoreHtml = giftTeaserHtml();

    /* ITEMS */
    body.innerHTML = goalHtml + giftRestoreHtml + cart.items.map(item => rvlIsGift(item) ? giftLineHtml(item) : `
      <div class="cart-item">
        <a href="${item.url}"><img class="cart-item__img" src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="107"></a>
        <div class="cart-item__info">
          <div>
            <div class="cart-item__vendor">${item.vendor}</div>
            <div class="cart-item__name">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          </div>
          <div class="cart-item__bottom">
            <div class="cart-item__qty" aria-label="Quantity">
              <button type="button" class="cart-item__qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" class="cart-item__qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <div style="display:flex;align-items:center;gap:12px">
              ${drawerPriceHtml(item)}
              <span class="cart-item__remove" data-key="${item.key}">Remove</span>
            </div>
          </div>
        </div>
      </div>`).join('');

    body.onchange = async event => {
      const giftSelect = event.target.closest('[data-gift-change]');
      if (giftSelect) { rvlSaveGiftState({ variantId: giftSelect.value, skip: false }); await this.render(); }
    };
    body.onclick = async event => {
      if (event.target.closest('[data-gift-restore]')) { rvlSaveGiftState({ skip: false }); await this.render(); return; }
      const removeButton = event.target.closest('.cart-item__remove');
      if (removeButton) { if (removeButton.dataset.gift) rvlSaveGiftState({ skip: true }); await this.removeItem(removeButton.dataset.key); await this.render(); return; }
      const quantityButton = event.target.closest('.cart-item__qty-btn');
      if (quantityButton) { await this.changeItem(quantityButton.dataset.key, Number(quantityButton.dataset.qty)); await this.render(); }
    };

    /* FOOTER */
    if (footer) {
      footer.innerHTML = `
        ${(visualTierSavings + giftSavings) > 0 ? `<div class="cart-savings">You save <strong>${formatMoney(visualTierSavings + giftSavings)}</strong> with the Christmas offer</div>` : ''}
<div class="cart-total"><span>Total</span><span>${formatMoney(visualCartTotal)}</span></div>

        <a href="/checkout" class="cart-drawer-checkout">Secure checkout</a>
        <div class="cart-drawer-checkout-sub">
          <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Secure payment via Shopify Payments
        </div>
        <a href="/collections" class="cart-drawer-continue" onclick="toggleCart(false)">&#8592; Continue shopping</a>
        ${paymentLogosHtml()}
            <div class="cart-drawer-payment" style="display:none">
          <div class="cart-drawer-payment-label">
            <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Accepted payments
          </div>
          <div class="cart-drawer-logos">
            <span class="cart-drawer-logo" title="Visa"><svg viewBox="0 0 48 16" xmlns="http://www.w3.org/2000/svg"><path d="M18.6 1.1L12 14.9h-3.9L4.7 4.3C4.5 3.5 4.2 3 3.6 2.7 2.7 2.2 1.3 1.7 0 1.4l.1-.3h6.3c.8 0 1.5.6 1.7 1.4l1.6 8.3 3.9-9.7h3.9zm15.4 9.3c0-3.8-5.2-4-5.2-5.7 0-.5.5-1.1 1.6-1.2 1.4-.1 2.4.2 3.2.5l.6-2.7C33.4.9 32.3.6 31 .6c-3.7 0-6.3 2-6.3 4.8 0 2.1 1.9 3.2 3.3 3.9 1.5.7 2 1.2 2 1.8 0 1-1.2 1.4-2.3 1.4-1.4 0-2.6-.3-3.6-.8l-.6 2.8c1 .4 2.4.7 4 .7 3.9 0 6.4-1.9 6.5-4.8zm9.7 4.5H48L45.1.6h-3.3c-.7 0-1.4.4-1.7 1.1l-5.5 13.2h3.9l.8-2.1h4.7zm-3.3-4l1.9-5.3.7 3.5-2.6 1.8zm-15.7-9L21.5 14.9h-3.7L21 .7h3.7z" fill="#1A1F71"/></svg></span>
            <span class="cart-drawer-logo" title="Mastercard"><svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="12" r="10" fill="#EB001B"/><circle cx="24" cy="12" r="10" fill="#F79E1B"/><path d="M19 4.5a10 10 0 0 1 0 15A10 10 0 0 1 19 4.5z" fill="#FF5F00"/></svg></span>
            <span class="cart-drawer-logo" title="PayPal"><svg viewBox="0 0 48 16" xmlns="http://www.w3.org/2000/svg"><path d="M6 1h5.5c2.5 0 3.7 1.3 3.5 3.3-.3 2.4-2 3.7-4.4 3.7H9l-.7 4H5.5L6 1zm2.5 5h1.5c1 0 1.7-.5 1.8-1.5.1-.7-.3-1.1-1.2-1.1H9l-.5 2.6z" fill="#003087"/><path d="M15 1h5.5c2.5 0 3.7 1.3 3.5 3.3-.3 2.4-2 3.7-4.4 3.7H18l-.7 4H14.5L15 1zm2.5 5h1.5c1 0 1.7-.5 1.8-1.5.1-.7-.3-1.1-1.2-1.1H18l-.5 2.6z" fill="#009CDE"/></svg></span>
            <span class="cart-drawer-logo" title="Apple Pay"><svg viewBox="0 0 52 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.8 3.8c-.6.7-1.5 1.2-2.4 1.1-.1-.9.3-1.8.8-2.4.6-.7 1.6-1.2 2.4-1.3.1.9-.2 1.8-.8 2.6zm.8 1.3c-1.3-.1-2.5.8-3.1.8S5.4 5 4.2 5C2.8 5.1 1.5 5.9.8 7.1c-1.4 2.5-.4 6.2 1 8.2.7 1 1.5 2.1 2.6 2.1s1.4-.6 2.7-.6 1.5.6 2.7.6 1.8-1 2.5-2c.8-1.1 1.1-2.2 1.1-2.3 0 0-2.1-.8-2.1-3.2 0-2 1.7-3 1.7-3.1-.9-1.3-2.3-1.5-2.9-1.6zM19 5v10h2.3V11h3.1c2.8 0 4.8-1.9 4.8-4.7 0-2.7-1.9-4.6-4.7-4.6H19zm2.3 2h2.6c1.9 0 3 1 3 2.7s-1.1 2.7-3 2.7h-2.6V7z" fill="#000"/></svg></span>
            <span class="cart-drawer-logo" title="" style="display:none"><svg viewBox="0 0 52 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.7 9.2c0-.3 0-.6-.1-.9H6.5v1.7H9.4c-.1.7-.5 1.3-1 1.7v1.4h1.7c1-.9 1.6-2.3 1.6-3.9z" fill="#4285F4"/><path d="M6.5 13.7c1.5 0 2.7-.5 3.6-1.4l-1.7-1.3c-.5.3-1.1.5-1.9.5-1.4 0-2.6-1-3-2.3H1.7v1.4c.9 1.7 2.7 3.1 4.8 3.1z" fill="#34A853"/><path d="M3.5 9.2c-.2-.6-.2-1.3 0-1.9V5.9H1.7a5.6 5.6 0 0 0 0 6.2L3.5 10.7V9.2z" fill="#FBBC04"/><path d="M6.5 5c.8 0 1.5.3 2.1.8l1.5-1.5C9 3.3 7.8 2.8 6.5 2.8 4.4 2.8 2.6 4 1.7 5.9l1.8 1.4C4 6 5.1 5 6.5 5z" fill="#EA4335"/></svg></span>
          </div>
        </div>`;
    }
  },
  updateCount(count) { $$('.cart-count').forEach(el => { el.textContent = count; el.classList.toggle('hidden', count === 0); }); }
};

